import { FiscalYear, ProjectAreaOfFocus, Club } from './';

export class ClubProject {
    constructor(clubProjectId:string = "", name:string = "", description:string = "") {
        this.ClubProjectId = clubProjectId;
        this.Name = name;
        this.Description = description;
    }
    
    public ClubProjectId:string;

    public ClubId:string;
    public Club:Club;

    public FiscalYearId:number;
    public FiscalYear:FiscalYear;
    
    public Name:string;

    public Description:string;

    public StartDate:Date;

    public EndDate:Date;

    public NumVolunteersProjected:number;

    public NumVolunteersActual:number;

    public NumVolunteerHoursProjected:number;

    public NumVolunteerHoursActual:number;

    public CashContributionValueProjected:number;

    public CashContributionValueActual:number;

    public InKindContributionValueProjected:number;

    public InKindContributionValueActual:number;

    public ProjectAreaOfFocusId:number;
    public ProjectAreaOfFocus:ProjectAreaOfFocus;

    public IsCompleted:boolean;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/entities/club-project.ts